import { createFileRoute } from "@tanstack/react-router";
import { EmployeesPage } from "../../pages/dashboard/employees/Employees.page";

import {
  toSearchEnum,
  toSearchInt,
  toSearchPageSize,
  toSearchString,
  VALID_PAGE_SIZES,
} from "../../lib/searchParams";
import type { ValidPageSize } from "../../lib/searchParams";

export {
  toSearchEnum,
  toSearchInt,
  toSearchPageSize,
  toSearchString,
  VALID_PAGE_SIZES,
};

/** URL search parameters for the employees list route. */
type tEmployeeSearch = {
  /** Free-text name search forwarded to the Employees API as `filterTerm`. */
  filterTerm: string;
  /** Work location type filter — matches WorkLocationType enum values or "" for All. */
  work_location_type: string;
  /** Employment type filter — matches EmploymentType enum values or "" for All. */
  employment_type: string;
  /** Employment status filter ("active" | "terminated" | ""). */
  status: string;
  /**
   * Worksite location filter (city / site name).
   * Pending backend support — stored in URL now so the UI filter persists;
   * has no effect on API results until the backend adds the query param.
   */
  work_location: string;
  /** 1-based current page number. */
  page: number;
  /** Number of rows displayed per page. Must be one of the values in VALID_PAGE_SIZES. */
  pageSize: ValidPageSize;
};

export const Route = createFileRoute("/_protected/dashboard/employees/")({
  validateSearch: (search: Record<string, unknown>): tEmployeeSearch => ({
    filterTerm: toSearchString(search.filterTerm),
    // Clamp enum-like params to their supported sets so invalid deep-linked
    // values default to "" ("All") instead of forwarding garbage to the API
    // or leaving the <select> in an unmatched blank state.
    work_location_type: toSearchEnum(search.work_location_type, ["remote", "onsite", "hybrid"] as const),
    employment_type: toSearchEnum(search.employment_type, ["full_time", "part_time", "seasonal", "temp"] as const),
    status: toSearchEnum(search.status, ["active", "terminated"] as const),
    work_location: toSearchString(search.work_location),
    page: toSearchInt(search.page, 1),
    pageSize: toSearchPageSize(search.pageSize),
  }),
  component: EmployeesPage,
});
